function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 16.5a7.54 7.54 0 01-1.94-.25l.49-1.93a5.79 5.79 0 002.38.1 5.77 5.77 0 002.05-.72 6 6 0 002.22-8.18 6 6 0 10-10.41 6l-1.74 1a8 8 0 1114.67-1.92 8 8 0 01-6.47 5.8 7.61 7.61 0 01-1.25.1z",
  fill: "#1696cc"
});

function SvgCompanyFormationsSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17"
  }, props), _ref);
}

export default SvgCompanyFormationsSpinner;